module.exports = __webpack_public_path__ + "media/images/iconSocialLink__inactive--dark-9a578ec56812ad82146b03ef4cff8fff.png";